import { getRequest, postRequest, putRequest } from "../services/apiHelpers";

export const getAuthors = async (params) => {
  try {
    const res = await getRequest({ url: "authors", query: params });
    return res;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const postAuthor = async (payload) => {
  try {
    const res = await postRequest({ url: "authors", payload: payload });
    return res;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const putAuthor = async ({ id, payload }) => {
  try {
    const res = await putRequest({
      url: "authors",
      payload: payload,
      query: { AUTHOR_ID: id },
    });
    return res;
  } catch (error) {
    throw new Error(error.message);
  }
};
